// extracted by mini-css-extract-plugin
export default {"wrap":"XF-z","articleImagesWrap":"YF-z","articleImage":"ZF-z","singleImage":"_F-z"};